import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=54aa9d5d"
import script from "./Actors.js?vue&type=script&lang=js&external"
export * from "./Actors.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports